const state = {
  files: [],
  urls: [],
  isUploading: false,
};

const mutations = {
  SET_FILES(state, files) {
    const newFiles = files.map((file) => ({
      id: `${file.name}-${file.size}-${file.lastModified}`,
      name: file.name,
      status: "pending",
      type: file.type,
      progress: 0,
      submissionId: null,
    }));

    state.files = [...state.files, ...newFiles];
  },
  ADD_URL(state, { url, id }) {
    state.urls.push({
      id,
      url,
      status: "pending",
      type: "url/",
    });
  },
  SET_FILE_STATUS(state, { file, status }) {
    const fileId = `${file.name}-${file.size}-${file.lastModified}`;
    const fileIndex = state.files.findIndex((f) => f.id === fileId);

    if (fileIndex !== -1) {
      state.files[fileIndex].status = status;
    }
  },
  SET_URL_STATUS(state, { urlId, status }) {
    const urlIndex = state.urls.findIndex((u) => u.id === urlId);

    if (urlIndex !== -1) {
      state.urls[urlIndex].status = status;
    }
  },
  SET_FILE_PROGRESS(state, { file, progress }) {
    const fileId = `${file.name}-${file.size}-${file.lastModified}`;
    const fileIndex = state.files.findIndex((f) => f.id === fileId);

    if (fileIndex !== -1) {
      state.files[fileIndex].progress = progress;
    }
  },
  SET_FILE_SUBMISSION_ID(state, { file, submissionId }) {
    const fileId = `${file.name}-${file.size}-${file.lastModified}`;
    const fileIndex = state.files.findIndex((f) => f.id === fileId);

    if (fileIndex !== -1) {
      state.files[fileIndex].submissionId = submissionId;
    }
  },
  SET_IS_UPLOADING(state, isUploading) {
    state.isUploading = isUploading;
  },
  RESET_UPLOAD_STATE(state) {
    state.files = [];
    state.urls = [];
    state.isUploading = false;
  },
};

const getters = {
  uploadState: (state) => ({
    files: state.files,
    urls: state.urls,
    isUploading: state.isUploading,
  }),
  allUploadsCompleted: (state) => {
    const allFilesCompleted =
      state.files.length === 0 || state.files.every((file) => file.status === "completed" || file.status === "failed");

    const allUrlsCompleted =
      state.urls.length === 0 || state.urls.every((url) => url.status === "completed" || url.status === "failed");

    return allFilesCompleted && allUrlsCompleted && (state.files.length > 0 || state.urls.length > 0);
  },
  hasSuccessfulUploads: (state) => {
    const hasSuccessfulFiles = state.files.some((file) => file.status === "completed");
    const hasSuccessfulUrls = state.urls.some((url) => url.status === "completed");

    return hasSuccessfulFiles || hasSuccessfulUrls;
  },
};

const actions = {
  initializeUpload({ commit }, files) {
    commit("RESET_UPLOAD_STATE");
    commit("SET_FILES", files);
    commit("SET_IS_UPLOADING", true);
  },
  addUrl({ commit }, url) {
    const urlId = `url-${Date.now()}`;
    commit("ADD_URL", { url, id: urlId });
    commit("SET_IS_UPLOADING", true);

    return urlId;
  },
  completeFile({ commit }, file) {
    commit("SET_FILE_STATUS", { file, status: "completed" });
  },
  failFile({ commit }, file) {
    commit("SET_FILE_STATUS", { file, status: "failed" });
  },
  completeUrl({ commit }, urlId) {
    commit("SET_URL_STATUS", { urlId, status: "completed" });
  },
  failUrl({ commit }, urlId) {
    commit("SET_URL_STATUS", { urlId, status: "failed" });
  },
  updateFileProgress({ commit }, { file, progress }) {
    commit("SET_FILE_PROGRESS", { file, progress });
  },
  setFileSubmissionId({ commit }, { file, submissionId }) {
    commit("SET_FILE_SUBMISSION_ID", { file, submissionId });
  },
  resetUploadState({ commit }) {
    commit("RESET_UPLOAD_STATE");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
